<template>
    <div>
        <label v-if="title && title.trim().length > 0">
            {{ title }} <span class="text-danger">{{ isRequire ? '(*)' : '' }}</span>
        </label>
        <select 
            ref="select" 
            class="form-control" 
            :disabled="isReadOnly || false" 
            :multiple="isMultiple || false" 
            :style="{ 
                border: '1px solid #ced4da',
                'border-radius' : '.25rem',
                height: heightSelect || 'auto' }">
            <option value=""></option>
            <option v-for="item in options" :value="item.id" :key="item.id">{{ formatDisplayValue(item) }}</option> 
        </select>
        <div class="text-danger text-right mb-2" v-if="error">
            {{ error }}
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import { ref, toRefs } from "vue";
export default {
    name: "TheSelect2",
    props: {
        id: String,
        title: String,
        placeholder: String,
        options: Array,
        error: String,
        isMultiple: Boolean,
        isReadOnly: Boolean,
        isRequire: Boolean,
        isAllowClear: Boolean,
        initialValue: {
            type: [String, Number],
            default: null,
        },
        dropdownParent: String,
        heightSelect: String,
        displayFormat: {
            type: Function,
            required: false
        }
    },
    setup(props) {

    },
    watch: {
        error() {
            if(this.error) {
                $(this.$refs.select).addClass('is-invalid');
            } else {
                $(this.$refs.select).removeClass('is-invalid');
            }
        }
    },
    methods: {
        formatDisplayValue(item) {
            return this.displayFormat ? this.displayFormat(item) : item?.name; // Gọi hàm định dạng được truyền từ ngoài
        }
    },
    mounted() {
        let self = this;
        let selectElement = $(this.$refs.select);
        selectElement.select2({
            language: {
                noResults: function() {
                    return "Không có dữ liệu";
                }
            },
            placeholder: this.placeholder ? this.placeholder : 'Chọn ' + this.title,
            theme: "bootstrap4",
            allowClear: this.isAllowClear,
            //selectOnClose: true,            
            //closeOnSelect: true,
            dropdownParent: this.dropdownParent ? $('#'+ this.dropdownParent): null
        })
        .val(this.initialValue)
        .trigger('change')
        .on('change', function() {
             self.$emit('onChange', $(this).val());
        });
    }
}
</script>
<style>
</style>